export const getDeliveryMethodPrices = (deliveryMethod: GQL.IDeliveryMethod, weightInG: number) => {

  if (!deliveryMethod.prices) {
    return null;
  }

  // váha na kila
  const weightInKg = Math.round(weightInG) / 1000;

  // cena dopravy podle váhy ?
  if (deliveryMethod.pricesByWeight === true) {
    return deliveryMethod.prices.filter((price: GQL.IDeliveryMethodPrice) => {
      return (
        (!price.fromWeight || price.fromWeight <= weightInKg) && 
        (!price.toWeight || price.toWeight >= weightInKg)
      );
    });

  } else {
    return deliveryMethod.prices;

  }
};


// WEBPACK FOOTER //
// ./src/helpers/deliveryMethods/getDeliveryMethodPrices.ts